import {Component, Input, OnInit} from '@angular/core';
import {Contest} from '../../../model/contest/Contest';
import {Region} from '../../../model/location/Region';
import {localizeUserExamGrade, StatsType, UserExamGrade, UserExamStats} from '../../../model/stats/Stats';
import {School} from '../../../model/location/School';
import {User} from '../../../model/auth/User';
import {ContestTaskType, localizeContestTaskType} from '../../../model/contest/ContestTask';
import {UrlHelper} from '../../../helper/url.helper';
import {Session} from '../../../model/auth/Session';

@Component({
  selector: 'exam-results-table',
  templateUrl: './exam-results-table.component.html',
  styleUrls: ['./exam-results-table.component.scss']
})
export class ExamResultsTableComponent implements OnInit {

  readonly examGrades = UserExamGrade;
  readonly taskTypes = ContestTaskType;
  readonly statsTypes = StatsType;

  readonly mobileColumnsToDisplay = ['grade', 'name', 'points'];
  columnsToDisplay = ['grade', 'name', 'region', 'school_name', 'points'];

  @Input() regions: Map<string, string> = new Map<string, string>();
  @Input() examStats?: UserExamStats[];
  @Input() mobileView = false;

  @Input() showAnswerSheets = false;
  @Input() showLocation = true;
  @Input() showEmail = false;
  @Input() showGrade = false;
  @Input() showTimeSpent = false;

  @Input() caller?: User | null = null;
  @Input() callerSession?: Session;
  @Input() callerRegion?: Region;
  @Input() callerSchool?: School;

  @Input() contest?: Contest;

  readonly minutesLabel: string;
  readonly secondsLabel: string;

  constructor() {
    this.minutesLabel = $localize`:General|Minutes short label@@general-minutes-short-label:min`;
    this.secondsLabel = $localize`:General|Seconds short label@@general-seconds-short-label:sec`;
  }

  ngOnInit(): void {
    this.columnsToDisplay = this.showLocation
      ? ['grade', 'name', 'region', 'school_name', 'points']
      : ['grade', 'name', 'points'];
    if (this.showEmail) this.columnsToDisplay.splice(2, 0, 'email');
    if (this.showGrade) this.columnsToDisplay.splice(this.columnsToDisplay.length - 1, 0, 'school_grade');
    if (this.showTimeSpent) this.columnsToDisplay.splice(this.columnsToDisplay.length - 1, 0, 'time_spent');
  }

  localizeTaskType(taskType?: ContestTaskType) {
    return taskType ? localizeContestTaskType(taskType) : '';
  }

  localizeExamGrade(grade: UserExamGrade) {
    return localizeUserExamGrade(grade);
  }

  canSeeExamCard(stats: UserExamStats): boolean {
    return stats.grade != undefined
      && (this.callerRegion == undefined || this.callerRegion.id == stats.regionId)
      && (this.callerSchool == undefined || this.callerSchool.id == stats.schoolId)
      && (!!this.callerSession && (!this.callerSession.isStudent() || stats.userId == this.caller?.id));

  }

  getExamCardUrl(stats: UserExamStats): string {
    return `${UrlHelper.STATS_EXAM_CARD_PATH}${this.contest?.id}/${stats.userId}`;
  }

  formatTime(duration = 0): string {
    const seconds = Math.floor((duration / 1000) % 60);
    const hours   = Math.floor((duration / (1000*60*60)) % 24);
    const minutes = Math.floor((duration / (1000 * 60)) % 60) + hours * 60;

    return `${minutes} ${this.minutesLabel}, ${seconds} ${this.secondsLabel}`;
  }
}
